const ALERT = {
    INFO : 'info-snack',
    SUCCESS : 'success-snack',
    WARNING : 'warning-snack',
    ERROR : 'error-snack'
}
exports.ALERT = ALERT;
